// Phase 10 — Subscriptions module copy strings.

export const subscriptions = {
  pageTitle: 'Subscriptions',
  pageSubtitle: 'Track your recurring subscriptions.',
  emptyTitle: 'No subscriptions tracked',
  emptyBody: 'Add a subscription to start tracking billing cycles.',
  loadingLabel: 'Loading subscriptions…',
  errorTitle: 'Could not load subscriptions',
  errorBody: 'Check your connection and try again.',
  retry: 'Retry',
  addLabel: 'Add subscription',
  editLabel: 'Edit subscription',
  saveLabel: 'Save',
  deleteLabel: 'Delete',
  nameLabel: 'Name',
  providerLabel: 'Provider',
  amountLabel: 'Monthly amount',
  billingCycleLabel: 'Billing cycle',
  nextBillingLabel: 'Next billing date',
  categoryLabel: 'Category',
  activeLabel: 'Active',
  notesLabel: 'Notes',
  cycleMonthly: 'Monthly',
  cycleYearly: 'Yearly',
  cycleWeekly: 'Weekly',
  deletedToast: 'Subscription removed.',
  createdToast: 'Subscription saved.',
  updatedToast: 'Subscription updated.',
  dashboardTitle: 'Subscriptions',
  dashboardSummary: (count: number, monthly: string) =>
    `${count} active — ${monthly}/mo`,
  dashboardEmpty: 'No active subscriptions',
} as const;
